import React, {
    useState,
} from "react";


const BasicSettings =
    () => {

        const [
            form,
            setForm,
        ] =
            useState({
                currency:
                    "INR",

                timezone:
                    "Asia/Kolkata",

                dateFormat:
                    "DD-MM-YYYY",

                country:
                    "India",

                state:
                    "",
            });


        const handleChange =
            (
                event
            ) => {

                const {
                    name,
                    value,
                } =
                    event.target;


                setForm(
                    (
                        previous
                    ) => ({
                        ...previous,

                        [name]:
                            value,
                    })
                );

            };


        const handleSubmit =
            (
                event
            ) => {

                event.preventDefault();

            };


        return (

            <form
                onSubmit={
                    handleSubmit
                }
            >

                <div className="settings-section-header">

                    <div>

                        <h2>
                            Basic Settings
                        </h2>

                        <p>
                            Configure common preferences for your business account.
                        </p>

                    </div>

                </div>


                <div className="settings-form-grid">

                    <div className="settings-field">

                        <label>
                            Default Currency
                        </label>

                        <select
                            name="currency"

                            value={
                                form.currency
                            }

                            onChange={
                                handleChange
                            }
                        >

                            <option value="INR">
                                INR - Indian Rupee
                            </option>

                            <option value="USD">
                                USD - US Dollar
                            </option>

                            <option value="AED">
                                AED - UAE Dirham
                            </option>

                        </select>

                    </div>


                    <div className="settings-field">

                        <label>
                            Timezone
                        </label>

                        <select
                            name="timezone"

                            value={
                                form.timezone
                            }

                            onChange={
                                handleChange
                            }
                        >

                            <option value="Asia/Kolkata">
                                Asia/Kolkata
                            </option>

                            <option value="Asia/Dubai">
                                Asia/Dubai
                            </option>

                        </select>

                    </div>


                    <div className="settings-field">

                        <label>
                            Date Format
                        </label>

                        <select
                            name="dateFormat"

                            value={
                                form.dateFormat
                            }

                            onChange={
                                handleChange
                            }
                        >

                            <option value="DD-MM-YYYY">
                                DD-MM-YYYY
                            </option>

                            <option value="YYYY-MM-DD">
                                YYYY-MM-DD
                            </option>

                            <option value="MM-DD-YYYY">
                                MM-DD-YYYY
                            </option>

                        </select>

                    </div>


                    <div className="settings-field">

                        <label>
                            Default Country
                        </label>

                        <input
                            type="text"

                            name="country"

                            value={
                                form.country
                            }

                            onChange={
                                handleChange
                            }

                            placeholder="Country"
                        />

                    </div>


                    <div className="settings-field">

                        <label>
                            Default State
                        </label>

                        <input
                            type="text"

                            name="state"

                            value={
                                form.state
                            }

                            onChange={
                                handleChange
                            }

                            placeholder="State"
                        />

                    </div>

                </div>


                <div className="settings-actions">

                    <button
                        type="submit"
                        className="settings-save-button"
                    >

                        Save Settings

                    </button>

                </div>

            </form>

        );

    };


export default BasicSettings;